import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { DataSourceOrdenacaoInsensivel } from '../../helpers/ordenacao-tabela.helper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { firstValueFrom, forkJoin, Observable, of } from 'rxjs';
import { LoadingBoxComponent } from '../../components/loading-box/loading-box.component';
import { AlertService, AlertType } from '../../services/alert.service';
import { ProdutoListStruct } from '../../services/structs/produto/produto-list.struct';
import { EtiquetaLookupItemStruct } from '../../services/structs/etiqueta/etiqueta-lookup-item.struct';
import { ConfiguracaoEtiquetaService } from '../../services/apis/etiqueta/configuracao-etiqueta.service';
import { ImpressaoEtiquetaService } from '../../services/apis/etiqueta/impressao-etiqueta.service';
import { EtiquetaImprimirRequest } from '../../services/requests/etiqueta/etiqueta-imprimir.request';
import { ConfiguracaoEtiqueta } from '../../services/models/etiqueta/configuracao-etiqueta.model';
import { ConfiguracaoEtiquetaCampo } from '../../services/models/etiqueta/configuracao-etiqueta-campo.model';
import { EtiquetaCampoRequest } from '../../services/requests/etiqueta/etiqueta-campo.request';
import { ProdutoService } from '../../services/apis/produto/produto.service';
import { PessoaService } from '../../services/apis/pessoa/pessoa.service';
import { EtiquetaLookupService } from '../../services/apis/etiqueta/etiqueta-lookup.service';
import { ProdutoGerarDadosEtiquetaRequest } from '../../services/requests/produto/produto-gerar-dados-etiqueta.request';
import { ProdutoGerarDadosEtiquetaResponse } from '../../services/responses/produto/produto-gerar-dados-etiqueta.response';
import { ListaPrecoStruct } from '../../services/structs/produto/lista-preco.struct';
import { LocalizacaoEstoque } from '../../services/models/produto/localizacao-estoque.model';
import { ModeloEtiqueta } from '../../services/models/etiqueta/modelo-etiqueta.model';
import {
  ImpressaoEtiquetaPreviewDialogComponent,
  ImpressaoEtiquetaPreviewDialogData,
} from '../../components/impressao-etiqueta-preview-dialog/impressao-etiqueta-preview-dialog.component';
import { EmpresaEtiquetaDadosService } from '../../services/etiqueta/empresa-etiqueta-dados.service';
import { ConfirmModalComponent } from '../../components/confirm-modal/confirm-modal.component';
import { ProdutoEtiquetaOpcaoCodigoComposto } from '../../services/responses/produto/produto-etiqueta-opcoes-codigo-composto.response';
import { NgxCurrencyDirective } from 'ngx-currency';
import { MaskService } from '../../services/mask.service';

export interface ImprimirEtiquetasDialogData {
  listaProdutos: ProdutoListStruct[];
  listaConfiguracoes: EtiquetaLookupItemStruct[];
  listaPrecos: ListaPrecoStruct[];
  listaLocalizacaoEstoque: LocalizacaoEstoque[];
}

export interface ProdutoEtiquetaRow {
  idProduto: number;
  descricao: string;
  codigoSku?: string;
  gtinEan?: string;
  quantidade: number;
  isControlaLotes: boolean;
  isControlaSeries: boolean;
  idsLoteSelecionados: number[];
  idsSerieSelecionadas: number[];
  tipoIdentificador?: number | null;
  opcoesCodigoComposto: { id: number; descricao: string; saldoDisponivel?: number }[];
}

@Component({
  selector: 'app-imprimir-etiquetas-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatInputModule,
    MatTooltipModule,
    FormsModule,
    MatProgressSpinnerModule,
    LoadingBoxComponent,
    NgxCurrencyDirective,
  ],
  templateUrl: './imprimir-etiquetas-dialog.component.html',
  styleUrls: ['./imprimir-etiquetas-dialog.component.css'],
})
export class ImprimirEtiquetasDialogComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort!: MatSort;

  public integerMask = this.maskService.getIntegerMask();
  public listaConfiguracoes: EtiquetaLookupItemStruct[] = [];
  public listaPrecos: ListaPrecoStruct[] = [];
  public listaPrecosPromocionais: ListaPrecoStruct[] = [];
  public listaLocalizacaoEstoque: LocalizacaoEstoque[] = [];
  public idConfiguracaoSelecionada: number | null = null;
  public idListaPrecoSelecionada: number | null = null;
  public idListaPrecoPromocionalSelecionada: number | null = null;
  public idLocalizacaoEstoqueSelecionado: number | null = null;
  public usarQuantidadeEstoque: boolean = false;
  public produtos: ProdutoEtiquetaRow[] = [];
  public dataSource = new DataSourceOrdenacaoInsensivel<ProdutoEtiquetaRow>([]);
  public displayedColumns: string[] = ['descricao', 'codigoSku', 'quantidade'];
  public isLoading: boolean = false;
  public isLoadingConfiguracao: boolean = false;
  public isLoadingCodigoComposto: boolean = false;
  public tentativaImpressao: boolean = false;

  private configuracaoCarregada: ConfiguracaoEtiqueta | null = null;
  private camposCarregados: ConfiguracaoEtiquetaCampo[] = [];
  private modelosEtiqueta: ModeloEtiqueta[] = [];
  private readonly chaveCodigoCompostoEanLoteSerie = 'produto.codigo_composto_ean_lote_serie';

  constructor(
    public dialogRef: MatDialogRef<ImprimirEtiquetasDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImprimirEtiquetasDialogData,
    private alertService: AlertService,
    private configuracaoEtiquetaService: ConfiguracaoEtiquetaService,
    private impressaoEtiquetaService: ImpressaoEtiquetaService,
    private etiquetaLookupService: EtiquetaLookupService,
    private produtoService: ProdutoService,
    private pessoaService: PessoaService,
    private dialog: MatDialog,
    private empresaEtiquetaDadosService: EmpresaEtiquetaDadosService,
    private maskService: MaskService
  ) {}

  ngOnInit(): void {
    this.carregarModelosEtiqueta();

    this.listaConfiguracoes = this.data.listaConfiguracoes;
    this.listaPrecos = this.data.listaPrecos || [];
  this.listaLocalizacaoEstoque = this.data.listaLocalizacaoEstoque || [];

    this.listaPrecosPromocionais = this.listaPrecos.filter(
      x => x.listaPreco?.isPromocao && x.listaPreco?.isAtivo
    );

    const listaPrecoPadrao = this.listaPrecos.find(x => x.listaPreco?.isPadrao)?.listaPreco?.idListaPreco;
    this.idListaPrecoSelecionada = listaPrecoPadrao ?? this.listaPrecos[0]?.listaPreco?.idListaPreco ?? null;
    this.idListaPrecoPromocionalSelecionada = null;
    this.idLocalizacaoEstoqueSelecionado = null;

    this.produtos = this.data.listaProdutos.map(p => ({
      idProduto: p.idProduto,
      descricao: p.descricao,
      codigoSku: p.codigoSku,
      gtinEan: p.gtinEan,
      quantidade: 1,
      isControlaLotes: p.isControlaLotes === true,
      isControlaSeries: p.isControlaSeries === true,
      idsLoteSelecionados: [],
      idsSerieSelecionadas: [],
      tipoIdentificador: null,
      opcoesCodigoComposto: [],
    }));

    this.dataSource.data = this.produtos;
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  public onConfiguracaoChange(): void {
    if (!this.idConfiguracaoSelecionada) {
      this.configuracaoCarregada = null;
      this.camposCarregados = [];
      return;
    }

    this.isLoadingConfiguracao = true;
    this.configuracaoEtiquetaService.getByIdParaImpressao(this.idConfiguracaoSelecionada).subscribe({
      next: res => {
        this.isLoadingConfiguracao = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }
        this.configuracaoCarregada = res.configuracaoEtiqueta ?? null;
        if (this.configuracaoCarregada) {
          this.aplicarDimensoesDaConfiguracaoComModelo(this.configuracaoCarregada);
        }
        this.camposCarregados = res.campos || [];
        this.atualizarColunasCodigoComposto();
        this.carregarOpcoesCodigoCompostoSeNecessario();
      },
      error: () => {
        this.isLoadingConfiguracao = false;
        this.alertService.show('Erro', 'Falha ao carregar configuração de etiqueta.', AlertType.error);
      },
    });
  }

  public onCheckboxEstoqueChange(): void {
    if (this.usarQuantidadeEstoque && !this.usaCodigoCompostoEanLoteSerie()) {
      this.recalcularQuantidadesPorEstoque();
    } else {
      this.produtos.forEach(p => (p.quantidade = 1));
    }
    this.carregarOpcoesCodigoCompostoSeNecessario();
  }

  public onLocalizacaoChange(): void {
    if (this.usarQuantidadeEstoque && !this.usaCodigoCompostoEanLoteSerie()) {
      this.recalcularQuantidadesPorEstoque();
    }
    this.carregarOpcoesCodigoCompostoSeNecessario();
  }

  public get quantidadeTotal(): number {
    return this.calcularTotalEstimado();
  }

  public get isImprimirDisabled(): boolean {
    return this.isLoading
      || this.isLoadingConfiguracao
      || this.isLoadingCodigoComposto
      || this.quantidadeTotal <= 0;
  }

  public getImprimirTooltip(): string {
    if (this.quantidadeTotal <= 0) {
      return 'Não há etiquetas para imprimir.';
    }

    return '';
  }

  public gerarEtiquetas(): void {
    this.tentativaImpressao = true;

    if (this.isImprimirDisabled) {
      const tooltip = this.getImprimirTooltip();
      if (tooltip) {
        this.alertService.show('Atenção', tooltip, AlertType.warning);
      }
      return;
    }

    if (!this.idConfiguracaoSelecionada) {
      this.alertService.show(
        'Atenção',
        'Campo obrigatório: selecione um modelo de etiqueta.',
        AlertType.warning
      );
      return;
    }

    if (!this.configuracaoCarregada) {
      this.alertService.show(
        'Atenção',
        'Aguarde o carregamento da configuração de etiqueta selecionada.',
        AlertType.warning
      );
      return;
    }

    const campos = this.montarCamposRequest();
    if (campos.length === 0) {
      this.alertService.show(
        'Atenção',
        'A configuração selecionada não possui campos válidos para impressão.',
        AlertType.warning
      );
      return;
    }

    this.confirmarMultiplicacaoSeNecessario().then(confirmado => {
      if (!confirmado) {
        return;
      }

      const requestDados = this.montarRequestDadosEtiqueta(campos);
      this.gerarDadosEImprimir(requestDados, campos);
    });
  }

  private gerarDadosEImprimir(requestDados: ProdutoGerarDadosEtiquetaRequest, campos: EtiquetaCampoRequest[]): void {
    this.isLoading = true;
    this.produtoService.gerarDadosEtiqueta(requestDados).subscribe({
      next: (res: ProdutoGerarDadosEtiquetaResponse) => {
        if (res.isError) {
          if (this.isErroSemEstoque(res)) {
            this.tratarSemEstoqueEmTodosProdutos(res);
            return;
          }

          this.isLoading = false;
          this.alertService.show('Atenção', res.errorDescription, AlertType.warning);
          return;
        }

        this.aplicarQuantidadesEfetivas(res);

        if (!res.dadosEtiquetas || res.dadosEtiquetas.length === 0) {
          if (this.isErroSemEstoque(res)) {
            this.tratarSemEstoqueEmTodosProdutos(res);
            return;
          }

          this.isLoading = false;
          const mensagem = this.usarQuantidadeEstoque
            ? 'Nenhum dos produtos selecionados possuem estoque'
            : 'É necessário informar a quantidade de etiquetas para ao menos um produto.';
          this.alertService.show('Atenção', mensagem, AlertType.warning);
          return;
        }

        this.resolverNomesFornecedores(res).subscribe({
          next: () => this.enviarParaImpressao(res, campos),
          error: () => this.enviarParaImpressao(res, campos),
        });
      },
      error: () => {
        this.isLoading = false;
        this.alertService.show(
          'Erro',
          'Falha ao carregar dados reais para impressão das etiquetas.',
          AlertType.error
        );
      },
    });
  }

  private async enviarParaImpressao(res: ProdutoGerarDadosEtiquetaResponse, campos: EtiquetaCampoRequest[]): Promise<void> {
    const config = this.configuracaoCarregada!;
    const larguraPaginaMm = this.resolveLarguraPaginaMm(config);
    const alturaPaginaMm = this.resolveAlturaPaginaMm(config);
    const dadosEtiquetas = await this.empresaEtiquetaDadosService.enriquecerDadosEtiquetas(
      res.dadosEtiquetas,
      campos
    );

    const requestImpressao: EtiquetaImprimirRequest = {
      quantidade: dadosEtiquetas.length,
      larguraPaginaMm,
      alturaPaginaMm,
      margemSuperiorPaginaMm: config.margemSuperiorPaginaMm,
      margemInferiorPaginaMm: config.margemInferiorPaginaMm,
      margemEsquerdaPaginaMm: config.margemEsquerdaPaginaMm,
      margemDireitaPaginaMm: config.margemDireitaPaginaMm,
      espacamentoHorizontalMm: config.espacamentoHorizontalMm,
      espacamentoVerticalMm: config.espacamentoVerticalMm,
      etiquetaLarguraMm: config.etiquetaLarguraMm,
      etiquetaAlturaMm: config.etiquetaAlturaMm,
      qtdColunas: config.qtdColunas,
      qtdLinhas: config.qtdLinhas,
      idTipoOrientacaoImpressao: config.idTipoOrientacaoImpressao,
      idTipoFormatoImpressao: config.idTipoFormatoImpressao,
      campos,
      dadosEtiquetas,
    };

    this.impressaoEtiquetaService.gerarPreview(requestImpressao).subscribe({
      next: previewRes => {
        this.isLoading = false;

        if (previewRes.isError) {
          this.alertService.show('Erro', previewRes.errorDescription, AlertType.error);
          return;
        }

        this.dialog.open(ImpressaoEtiquetaPreviewDialogComponent, {
          width: '90vw',
          maxWidth: '1200px',
          maxHeight: '90vh',
          autoFocus: false,
          data: {
            htmlContent: previewRes.htmlContent,
            request: requestImpressao,
          } as ImpressaoEtiquetaPreviewDialogData,
        });
      },
      error: () => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Falha ao gerar pré-visualização.', AlertType.error);
      },
    });
  }

  private usaCodigoCompostoEanLoteSerie(): boolean {
    return this.camposCarregados.some(c => {
      if (!c.layoutJson) return false;
      try {
        const layout = JSON.parse(c.layoutJson) as { chave?: string };
        return layout.chave === this.chaveCodigoCompostoEanLoteSerie;
      } catch {
        return false;
      }
    });
  }

  private usaCampoLocalizacao(): boolean {
    return this.camposCarregados.some(c => {
      if (!c.layoutJson) return false;
      try {
        const layout = JSON.parse(c.layoutJson) as { chave?: string };
        return layout.chave === 'produto.localizacao_estoque';
      } catch {
        return false;
      }
    });
  }

  private atualizarColunasCodigoComposto(): void {
    const deveExibir = this.usaCodigoCompostoEanLoteSerie();
    this.displayedColumns = deveExibir
      ? ['descricao', 'codigoSku', 'codigoComposto', 'quantidade']
      : ['descricao', 'codigoSku', 'quantidade'];
  }

  private carregarOpcoesCodigoCompostoSeNecessario(): void {
    if (!this.usaCodigoCompostoEanLoteSerie()) {
      this.produtos.forEach(p => {
        p.opcoesCodigoComposto = [];
        p.idsLoteSelecionados = [];
        p.idsSerieSelecionadas = [];
        p.tipoIdentificador = null;
      });
      return;
    }

    const produtoIds = this.produtos.map(p => p.idProduto);

    if (produtoIds.length === 0) {
      return;
    }

    this.isLoadingCodigoComposto = true;
    this.produtoService.getOpcoesCodigoCompostoEtiqueta({
      idLocalizacaoEstoque: this.idLocalizacaoEstoqueSelecionado,
      usarQuantidadeEstoque: this.usarQuantidadeEstoque,
      produtoIds,
    }).subscribe({
      next: res => {
        this.isLoadingCodigoComposto = false;
        if (res.isError) {
          this.alertService.show('Atenção', res.errorDescription, AlertType.warning);
          return;
        }
        this.aplicarOpcoesCodigoComposto(res.list || []);
      },
      error: () => {
        this.isLoadingCodigoComposto = false;
        this.alertService.show('Erro', 'Falha ao carregar lotes/séries para etiqueta.', AlertType.error);
      },
    });
  }

  private aplicarOpcoesCodigoComposto(opcoes: ProdutoEtiquetaOpcaoCodigoComposto[]): void {
    const map = new Map<number, ProdutoEtiquetaOpcaoCodigoComposto>(opcoes.map(x => [x.idProduto, x]));

    this.produtos.forEach(produto => {
      const item = map.get(produto.idProduto);
      produto.tipoIdentificador = item?.tipoIdentificador ?? null;
      produto.opcoesCodigoComposto = item?.opcoes || [];
      produto.isControlaLotes = produto.tipoIdentificador === 1 || produto.isControlaLotes;
      produto.isControlaSeries = produto.tipoIdentificador === 2 || produto.isControlaSeries;

      if (produto.tipoIdentificador === 1) {
        produto.idsLoteSelecionados = produto.opcoesCodigoComposto.map(x => x.id);
        produto.idsSerieSelecionadas = [];
      } else if (produto.tipoIdentificador === 2) {
        produto.idsSerieSelecionadas = produto.opcoesCodigoComposto.map(x => x.id);
        produto.idsLoteSelecionados = [];
      } else {
        produto.idsLoteSelecionados = [];
        produto.idsSerieSelecionadas = [];
      }

      this.atualizarQuantidadeProdutoPorCodigoComposto(produto);
    });

    this.dataSource.data = this.produtos;
  }

  public getCodigoCompostoLabel(row: ProdutoEtiquetaRow): string {
    if (row.tipoIdentificador === 1) return 'Lotes';
    if (row.tipoIdentificador === 2) return 'Séries';
    if (row.isControlaLotes) return 'Lotes';
    if (row.isControlaSeries) return 'Séries';
    return 'Código composto';
  }

  public getCodigoCompostoSelecionado(row: ProdutoEtiquetaRow): number[] {
    return row.tipoIdentificador === 2 ? row.idsSerieSelecionadas : row.idsLoteSelecionados;
  }

  public setCodigoCompostoSelecionado(row: ProdutoEtiquetaRow, ids: number[]): void {
    if (row.tipoIdentificador === 2) {
      row.idsSerieSelecionadas = ids || [];
      this.atualizarQuantidadeProdutoPorCodigoComposto(row);
      return;
    }

    row.idsLoteSelecionados = ids || [];
    this.atualizarQuantidadeProdutoPorCodigoComposto(row);
  }

  public isCodigoCompostoDisabled(row: ProdutoEtiquetaRow): boolean {
    return this.isLoadingCodigoComposto || !row.tipoIdentificador || row.opcoesCodigoComposto.length === 0;
  }

  public getCodigoCompostoHint(row: ProdutoEtiquetaRow): string {
    if (this.isLoadingCodigoComposto) {
      return 'Carregando opções...';
    }

    if (!row.tipoIdentificador) {
      return 'Produto sem controle de lote ou série.';
    }

    if (row.opcoesCodigoComposto.length > 0) {
      return '';
    }

    if (row.tipoIdentificador === 1) {
      return this.usarQuantidadeEstoque
        ? 'Nenhum lote com estoque disponível.'
        : 'Nenhum lote relacionado ao produto.';
    }

    return this.usarQuantidadeEstoque
      ? 'Nenhuma série com estoque disponível.'
      : 'Nenhuma série relacionada ao produto.';
  }

  private isErroSemEstoque(res: ProdutoGerarDadosEtiquetaResponse): boolean {
    return this.usarQuantidadeEstoque
      && (res.quantidadeTotal ?? 0) <= 0
      && String(res.errorDescription ?? '').toLowerCase().includes('possuem estoque');
  }

  private atualizarQuantidadeProdutoPorCodigoComposto(row: ProdutoEtiquetaRow): void {
    if (!this.usarQuantidadeEstoque || !this.usaCodigoCompostoEanLoteSerie() || !row.tipoIdentificador) {
      return;
    }

    const idsSelecionados = new Set(this.getCodigoCompostoSelecionado(row));
    row.quantidade = row.opcoesCodigoComposto
      .filter(opcao => idsSelecionados.has(opcao.id))
      .reduce((sum, opcao) => sum + Math.floor(Number(opcao.saldoDisponivel || 0)), 0);
  }

  private async confirmarMultiplicacaoSeNecessario(): Promise<boolean> {
    const usaCodigoComposto = this.usaCodigoCompostoEanLoteSerie();
    const usaLocalizacao = this.usaCampoLocalizacao() && !this.idLocalizacaoEstoqueSelecionado;
    if (!usaCodigoComposto && !usaLocalizacao) {
      return true;
    }

    const totalEstimado = this.calcularTotalEstimado();
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '460px',
      data: {
        title: 'Confirmar quantidade',
        description: `A etiqueta possui campos que podem multiplicar a impressão por lote, série ou localização. O total estimado é de ${totalEstimado} etiqueta(s). Deseja continuar?`,
        buttonConfirm: 'Continuar',
        buttonClose: 'Cancelar',
      },
    });

    const result = await firstValueFrom(dialogRef.afterClosed());
    return result?.confirm === true;
  }

  private calcularTotalEstimado(): number {
    const usaCodigoComposto = this.usaCodigoCompostoEanLoteSerie();
    const qtdLocais = this.usaCampoLocalizacao() && !this.idLocalizacaoEstoqueSelecionado
      ? Math.max(this.listaLocalizacaoEstoque.length, 1)
      : 1;

    return this.produtos.reduce((sum, produto) => {
      if (this.usarQuantidadeEstoque) {
        if (usaCodigoComposto && produto.tipoIdentificador) {
          const idsSelecionados = new Set(this.getCodigoCompostoSelecionado(produto));
          return sum + produto.opcoesCodigoComposto
            .filter(opcao => idsSelecionados.has(opcao.id))
            .reduce((total, opcao) => total + Math.floor(Number(opcao.saldoDisponivel || 0)), 0);
        }

        return sum + Math.max(produto.quantidade || 0, 0);
      }

      const qtd = Math.max(produto.quantidade || 0, 0);
      const qtdCodigoComposto = usaCodigoComposto
        ? this.getQuantidadeCodigoCompostoSelecionado(produto)
        : 1;

      return sum + (qtd * qtdLocais * qtdCodigoComposto);
    }, 0);
  }

  private getQuantidadeCodigoCompostoSelecionado(produto: ProdutoEtiquetaRow): number {
    if (!produto.tipoIdentificador) {
      return produto.isControlaLotes || produto.isControlaSeries ? 0 : 1;
    }

    return this.getCodigoCompostoSelecionado(produto).length;
  }

  private toNumberOrZero(value: unknown): number {
    const parsed = Number(String(value ?? '').replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  private carregarModelosEtiqueta(): void {
    this.etiquetaLookupService.getLookup().subscribe({
      next: res => {
        if (!res.isError) {
          this.modelosEtiqueta = res.modelosEtiqueta || [];
          if (this.configuracaoCarregada) {
            this.aplicarDimensoesDaConfiguracaoComModelo(this.configuracaoCarregada);
          }
        }
      },
      error: () => {
        this.modelosEtiqueta = [];
      },
    });
  }

  private getModeloById(idModeloEtiqueta: unknown): ModeloEtiqueta | undefined {
    const id = this.toNumberOrZero(idModeloEtiqueta);
    if (id <= 0) {
      return undefined;
    }

    return this.modelosEtiqueta.find(m => m.idModeloEtiqueta === id);
  }

  private aplicarDimensoesDaConfiguracaoComModelo(config: ConfiguracaoEtiqueta): void {
    const modelo = this.getModeloById(config.idModeloEtiqueta);
    if (!modelo) {
      return;
    }

    if (this.toNumberOrZero(config.larguraPaginaMm) <= 0 && this.toNumberOrZero(modelo.larguraPaginaMm) > 0) {
      config.larguraPaginaMm = Number(this.toNumberOrZero(modelo.larguraPaginaMm).toFixed(2));
    }

    if (this.toNumberOrZero(config.alturaPaginaMm) <= 0 && this.toNumberOrZero(modelo.alturaPaginaMm) > 0) {
      config.alturaPaginaMm = Number(this.toNumberOrZero(modelo.alturaPaginaMm).toFixed(2));
    }
  }

  private resolveLarguraPaginaMm(config: ConfiguracaoEtiqueta): number | undefined {
    const larguraInformada = this.toNumberOrZero(config.larguraPaginaMm);
    if (larguraInformada > 0) {
      return Number(larguraInformada.toFixed(2));
    }

    const larguraModelo = this.toNumberOrZero(this.getModeloById(config.idModeloEtiqueta)?.larguraPaginaMm);
    if (larguraModelo > 0) {
      return Number(larguraModelo.toFixed(2));
    }

    return undefined;
  }

  private resolveAlturaPaginaMm(config: ConfiguracaoEtiqueta): number | undefined {
    const alturaInformada = this.toNumberOrZero(config.alturaPaginaMm);
    if (alturaInformada > 0) {
      return Number(alturaInformada.toFixed(2));
    }

    const alturaModelo = this.toNumberOrZero(this.getModeloById(config.idModeloEtiqueta)?.alturaPaginaMm);
    if (alturaModelo > 0) {
      return Number(alturaModelo.toFixed(2));
    }

    return undefined;
  }

  private resolverNomesFornecedores(res: ProdutoGerarDadosEtiquetaResponse): Observable<unknown> {
    const campoId = res.campoIdFornecedorNome;
    const mapa = res.fornecedorPadraoMap;

    if (!campoId || !mapa || Object.keys(mapa).length === 0) {
      return of(null);
    }

    const idsFornecedores = [...new Set(Object.values(mapa))];
    const requests = idsFornecedores.map(id => this.pessoaService.getById(id));

    return new Observable(observer => {
      forkJoin(requests).subscribe({
        next: responses => {
          const nomePorId = new Map<number, string>();
          responses.forEach((pessoaRes, index) => {
            if (!pessoaRes.isError && pessoaRes.pessoa) {
              nomePorId.set(idsFornecedores[index], pessoaRes.pessoa.nome);
            }
          });

          this.preencherNomesFornecedores(res, campoId, mapa, nomePorId);
          observer.next(null);
          observer.complete();
        },
        error: _err => {
          observer.next(null);
          observer.complete();
        },
      });
    });
  }

  private preencherNomesFornecedores(
    res: ProdutoGerarDadosEtiquetaResponse,
    campoId: string,
    fornecedorMap: Record<number, number>,
    nomePorId: Map<number, string>
  ): void {
    let offset = 0;
    for (const item of res.itens) {
      const idFornecedor = fornecedorMap[item.idProduto];
      const nome = idFornecedor ? (nomePorId.get(idFornecedor) ?? '') : '';

      for (let i = 0; i < item.quantidadeEfetiva; i++) {
        const idx = offset + i;
        if (idx < res.dadosEtiquetas.length) {
          res.dadosEtiquetas[idx][campoId] = nome;
        }
      }

      offset += item.quantidadeEfetiva;
    }
  }

  private montarCamposRequest(): EtiquetaCampoRequest[] {
    return this.camposCarregados
      .filter(c => c.layoutJson)
      .map(c => ({
        idTipoCampo: c.idTipoCampo,
        layoutJson: c.layoutJson,
      }));
  }

  private montarRequestDadosEtiqueta(campos: EtiquetaCampoRequest[]): ProdutoGerarDadosEtiquetaRequest {
    const request = new ProdutoGerarDadosEtiquetaRequest();
    request.idListaPreco = this.idListaPrecoSelecionada;
    request.idListaPrecoPromocional = this.idListaPrecoPromocionalSelecionada;
    request.idLocalizacaoEstoque = this.idLocalizacaoEstoqueSelecionado;
    request.usarQuantidadeEstoque = this.usarQuantidadeEstoque;
    request.campos = campos;
    request.produtos = this.produtos.map(p => ({
      idProduto: p.idProduto,
      quantidade: p.quantidade,
      idsLoteSelecionados: p.idsLoteSelecionados,
      idsSerieSelecionadas: p.idsSerieSelecionadas,
    }));
    return request;
  }

  private aplicarQuantidadesEfetivas(response: ProdutoGerarDadosEtiquetaResponse): void {
    if (!response.itens || response.itens.length === 0) {
      return;
    }

    const quantidadePorProduto = new Map<number, number>(
      response.itens.map(i => [i.idProduto, i.quantidadeEfetiva])
    );

    if (!this.usarQuantidadeEstoque) {
      return;
    }

    this.produtos.forEach(produto => {
      const quantidadeEfetiva = quantidadePorProduto.get(produto.idProduto);
      if (quantidadeEfetiva != null) {
        produto.quantidade = quantidadeEfetiva;
      }
    });

    this.dataSource.data = this.produtos;
  }

  private recalcularQuantidadesPorEstoque(): void {
    this.isLoading = true;

    const request = this.montarRequestDadosEtiqueta(this.montarCamposRequest());
    this.produtoService.gerarDadosEtiqueta(request).subscribe({
      next: (res: ProdutoGerarDadosEtiquetaResponse) => {
        if (res.isError) {
          if (this.usarQuantidadeEstoque && (res.quantidadeTotal ?? 0) <= 0) {
            this.tratarSemEstoqueEmTodosProdutos(res);
            return;
          }

          this.isLoading = false;
          this.alertService.show('Atenção', res.errorDescription, AlertType.warning);
          return;
        }

        this.aplicarQuantidadesEfetivas(res);
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Falha ao recalcular quantidades por estoque.', AlertType.error);
      },
    });
  }

  private tratarSemEstoqueEmTodosProdutos(response: ProdutoGerarDadosEtiquetaResponse): void {
    if (response.itens?.length) {
      this.aplicarQuantidadesEfetivas(response);
    } else {
      this.produtos.forEach(produto => {
        produto.quantidade = 0;
      });
      this.dataSource.data = this.produtos;
    }

    this.isLoading = false;
    this.alertService.show(
      'Atenção',
      response.errorDescription || 'Nenhum dos produtos selecionados possuem estoque',
      AlertType.warning
    );
  }

  public fechar(): void {
    this.dialogRef.close();
  }
}
